var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"click":_vm.clickHandler}},[_c('lottie-animation',{staticClass:"player",attrs:{"loop":false,"width":260,"path":_vm.lottiePath,"autoPlay":false},on:{"AnimControl":_vm.setAnimController}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }